// extracted by mini-css-extract-plugin
export default {"header":"QR-z","logo":"RR-z","signin":"SR-z"};